import styled from 'styled-components';
import { lFColor2 } from '../LFHeader.styled';
import { topBarColor2 } from 'pages/styles';

export const Container = styled.div`
  width: 90vw;
  height: max-content;
  max-width: 220px;
  padding: 20px;
  background: white;
  border-radius: 3px;
`;

export const MainLabel = styled.div`
  font-size: 20px;
  color: black;
  margin-bottom: 35px;
  font-weight: 700;
`;

export const Button1 = styled.div`
  color: #1685ec;
  margin-top: 20px;
  width: max-content;
`;

export const Button = styled.div`
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background: ${lFColor2};
  color: white;
  width: max-content;
  &:hover {
    background: ${topBarColor2};
  }
`;
